










































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {isResetUrl} from "@/services/routeHelper";
import {path} from "ramda";
import {IApiErrors} from "@/models/ApiModels";
import {IReset} from "@/models/loginModels";
import {resetPassword} from "@/services/loginManager";
import {errorHandler} from "@/services/services";
import {stripHtmlTags} from "@/helpers/stringHelpers";

const userDataModule = namespace("userData");

@Component({
  name: 'ResetPasswordForm',
  components: {},
})
export default class ResetPasswordForm extends Vue {
  private loading: boolean = false;

  private email: string = "";
  private password: string = "";
  private token: string = "";
  private repeatPassword: string = "";

  private errors: IApiErrors = {};


  private get isResetUrl(): boolean {
    return isResetUrl(this.$route);
  }

  private created() {
    this.updateIfResetLink();
  }

  @Watch("$route")
  private updateIfResetLink() {
    if (this.isResetUrl) {
      this.routeParamsOperation();
    }
  }

  private routeParamsOperation() {
    const token: string|undefined = path(['params', 'token'], this.$route);

    this.token = token ? token : "";
  }

  private sanitizeInputs() {
    this.email = stripHtmlTags(this.email);
  }

  private sendResetForm() {
    if (this.activeButton) {
      this.sanitizeInputs();
      this.clearErrors();
      this.loading = true;

      const sendResetBody: IReset = {
        email: this.email,
        token: this.token,
        password: this.password,
        password_confirmation: this.repeatPassword,
      };

      resetPassword(sendResetBody)
          .then(this.showSuccess)
          .catch(this.showErrors)
          .finally(() => this.loading = false);
    }
  }

  private showSuccess() {
    this.$uiBus.emit("genericMessage:show", this.$t('reset.success'));
  }

  private showErrors(err: any) {
    const errors = errorHandler.handleErrorsResponse(err, 'reset.errors');
    Vue.set(this, 'errors', errors);
  }

  private get activeButton() {
    return this.email !== ""
        && this.password !== ""
        && this.repeatPassword !== ""
        && this.token !== "";
  }


  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private removeError(e: any) {
    Vue.set(this.errors, e, '');
  }
}
